<template>
  <ul class="c-book-zoom-picker">
    <li
      v-for="level in zoomLevels"
      :key="'zoom_' + level"
      class="c-book-zoom-picker__item"
    >
      <button
        class="c-book-zoom-picker__btn"
        :class="{
          'c-book-zoom-picker__btn--active': zoomLevel === level,
        }"
        @click="$emit('change-zoom', level)"
      >
        {{ level }} %
      </button>
    </li>
    <li class="c-book-zoom-picker__item">
      <button
        class="c-book-zoom-picker__btn"
        :class="{ 'c-book-zoom-picker__btn--active': fitToWindow }"
        @click="$emit('fit-window-clicked')"
      >
        {{ $t('ZOOM_FIT_TO_SCREEN') }}
      </button>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'BookZoomPicker',

  computed: {
    zoomLevels() {
      const levels = []
      let i = 0
      do {
        levels.push(25 * (i + 1))
        i++
      } while (i < 8)
      return levels
    },
  },
  props: {
    zoomLevel: Number,
    fitToWindow: Boolean,
  },
}
</script>

<style lang="scss">
@import '@/assets/scss/_vars.scss';
@import '@/assets/scss/_mixin.scss';

.c-book-zoom-picker {
  background-color: $blue;
  color: #fff;
  border-radius: 8px;
  margin-bottom: 4px;
  width: 160px;
}

.c-book-zoom-picker__btn {
  @include btnReset();
  background: transparent;
  width: 100%;
  cursor: pointer;
  line-height: 1.75;
  border-bottom: 1px solid #fff;

  &:hover {
    font-weight: 700;
  }
  
  &--active {
    font-weight: 700;
  }
  @include a11yOutline();
}
.c-book-zoom-picker__item {
  &:last-of-type {
    .c-book-zoom-picker__btn {
      border: none;
    }
  }
}
</style>
